(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var slides = Array.from(root.querySelectorAll('[data-home-slide]'));
    var buttons = Array.from(root.querySelectorAll('[data-home-slide-button]'));
    var active = 0;
    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.hidden = i !== active; });
      buttons.forEach(function (button, i) { button.setAttribute('aria-pressed', String(i === active)); });
    }
    buttons.forEach(function (button, i) { button.addEventListener('click', function () { show(i); }); });
    var startX = null;
    root.addEventListener('touchstart', function (event) { startX = event.touches[0].clientX; }, {passive: true});
    root.addEventListener('touchend', function (event) { if (startX === null) return; var distance = event.changedTouches[0].clientX - startX; startX = null; if (Math.abs(distance) > 60) show(active + (distance < 0 ? 1 : -1)); }, {passive:true});
  }
  document.querySelectorAll('[data-home-featured]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-home-featured]').forEach(init); });
})();
